import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import VTooltip from 'v-tooltip'
import { rtdbPlugin } from 'vuefire'
import './fb/firebase'
import VueIntro from 'vue-introjs'
import 'dtoaster/dist/dtoaster.css'
import DToaster from 'dtoaster'
import ToasterPresets from './helpers/toast_presets.json'
import vSelect from 'vue-select';
import CONST from "@/helpers/constants";

const {AVATARS_PATH} = CONST;

// import { reportEvent} from './helpers/utils'

import Lang from 'vuejs-localization'

import './registerServiceWorker'
Lang.requireAll(require.context('./lang', true, /\.js$/))

Vue.use(VTooltip)
VTooltip.options.defaultTrigger = 'hover focus click'
VTooltip.options.autoHide = false
Vue.use(Lang)
Vue.use(VueIntro)

Vue.config.productionTip = false
Vue.use(rtdbPlugin)

Vue.use(DToaster, {
  presets: ToasterPresets,
  position: 'top-right', //toasts container position on the screen
  containerOffset: '45px', //toasts container offset from top/bottom of the screen
})

Vue.prototype.$avatars = AVATARS_PATH;

// android stub
/*window.Android = {
  sendJsMsgToWebView() {
    console.log('sendJsMsgToWebView');
  },
  sendJsMsgToWebViewForPermission() {
    console.log('sendJsMsgToWebViewForPermission');
  },
  onRegistrationEnd() {
    console.log('onRegistrationEnd');
  },
  userSignOut() {
    console.log('userSignOut');
  }
}*/


Vue.component('v-select', vSelect);

new Vue({
  router,
  store,
  render: h => h(App),
/*  beforeMount() {
    this.$OneSignal.init({
      appId: '0130663a-bce4-48e6-b3a0-9f25cd3ac110',
      safari_web_id: 'web.onesignal.auto.1f7bf174-83d3-440c-93ed-a44b9d28ad31',
    });
    this.$OneSignal.on('popoverShown', function() {
      console.log('Slide Prompt Shown');
    });
    this.$OneSignal.on('popoverAllowClick', function() {
      reportEvent('popoverClick', {oneSignalEnable: true});
    });
    this.$OneSignal.on('popoverCancelClick', function() {
      reportEvent('popoverClick', {oneSignalEnable: false});
    });
    this.$OneSignal.on('subscriptionChange', function(isSubscribed) {
      console.log("The user's subscription state is now:", isSubscribed);
    });
  }*/
}).$mount('#app')

